import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asuhan-kebidanan-gawat-darurat", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asuhan-kebidanan-gawat-darurat/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asuhan-kebidanan-gawat-darurat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asuhan-kebidanan-gawat-darurat/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function destroy(id) {
  const response = await http
    .deleteData(`/asuhan-kebidanan-gawat-darurat/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

function print(register_id) {
  window.open(
    `${http.getAPI()}/register/${register_id}/asuhan-kebidanan-gawat-darurat/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  print
};
